import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import { useEffect, useState } from 'react';

export const useLineMutations = ({
  addLine,
  addLineAction,
  cleanAddLine,
  removeLine,
  removeLineAction,
  cleanRemoveLine,
  legalId,
  orderId,
  setLines,
  setValue,
  onError,
  unlockStatusDialog,
}) => {
  const [loading, setLoading] = useState(false);
  const [pendingLine, setPendingLine] = useState('');
  const [pendingRemoveLine, setPendingRemoveLine] = useState('');
  const [isRemoveDialogOpen, setIsRemoveDialogOpen] = useState(false);

  const addLineForm = (data) => {
    const { direct_number } = data || {};

    setPendingLine(direct_number || '');
    setLoading(true);
    addLineAction({
      legal_id: legalId,
      order_id: orderId,
      direct_number,
    });
  };

  const handleDeleteLine = (line) => {
    setPendingRemoveLine(line);
    setIsRemoveDialogOpen(true);
  };

  const handleCloseRemoveDialog = () => {
    setIsRemoveDialogOpen(false);
    setPendingRemoveLine('');
  };

  const handleConfirmRemoveLine = () => {
    if (!pendingRemoveLine) {
      return;
    }

    setLoading(true);
    setIsRemoveDialogOpen(false);
    removeLineAction({
      legal_id: legalId,
      order_id: orderId,
      direct_number: pendingRemoveLine,
    });
  };

  const formatPhoneNumber = (value) => {
    if (!value) {
      return '';
    }

    const digits = String(value).replace(/\D/g, '');

    if (digits.length !== 10) {
      return value;
    }

    return `${digits.slice(0, 3)} ${digits.slice(3, 6)} ${digits.slice(6)}`;
  };

  useEffect(() => {
    if (addLine?.status === 200) {
      setLoading(false);
      unlockStatusDialog();

      if (pendingLine) {
        setLines((currentLines) => [pendingLine, ...currentLines]);
        setPendingLine('');
      }
      cleanAddLine();
    } else if (addLine?.payload?.response?.status > 200) {
      unlockStatusDialog();
      onError({
        title: addLine?.payload?.response?.data?.title,
        message: addLine?.payload?.response?.data?.detail ?? 'Ocurrió un error.',
        icon: <ErrorOutlineOutlinedIcon sx={{ fontSize: 40, color: '#D32F2F' }} />,
      });
      setLoading(false);
      setPendingLine('');
    }

    setValue('direct_number', '');
  }, [addLine, cleanAddLine, onError, pendingLine, setLines, setValue, unlockStatusDialog]);

  useEffect(() => {
    if (removeLine?.status === 200) {
      setLoading(false);
      unlockStatusDialog();
      setLines((currentLines) => currentLines.filter((line) => line !== pendingRemoveLine));
      setPendingRemoveLine('');
      cleanRemoveLine();
    } else if (removeLine?.payload?.response?.status > 200) {
      unlockStatusDialog();
      onError({
        title: removeLine?.payload?.response?.data?.title,
        message: removeLine?.payload?.response?.data?.detail ?? 'Ocurrió un error.',
        icon: <ErrorOutlineOutlinedIcon sx={{ fontSize: 40, color: '#D32F2F' }} />,
      });
      setLoading(false);
      setPendingRemoveLine('');
      cleanRemoveLine();
    }

    setValue('direct_number', '');
  }, [
    cleanRemoveLine,
    onError,
    pendingRemoveLine,
    removeLine,
    setLines,
    setValue,
    unlockStatusDialog,
  ]);

  return {
    loading,
    addLineForm,
    handleDeleteLine,
    isRemoveDialogOpen,
    handleCloseRemoveDialog,
    handleConfirmRemoveLine,
    pendingRemoveLine,
    formatPhoneNumber,
  };
};
